
<div v-if="showBlock" class="ftu-block card">
  <icon :name="icon" />

  <div>
    <h3 class="secondary-font">
      {{ title }}
    </h3>

    <p>{{ description }}</p>
  </div>

  <icon-button icon="close" @click="dismiss" />
</div>
